export default "__VITE_ASSET__FpXBwe2Q__"